import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//- Get All
export const GetAllHomeBanner = createAsyncThunk(
  "homepage/homebanner/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.HomePage.HomeBanner}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "homebanner",
  initialState: {
    all_homebanner: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(GetAllHomeBanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllHomeBanner.fulfilled, (state, action) => {
     
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_homebanner = action.payload?.data || [];
      })
      .addCase(GetAllHomeBanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

  },
});

export const {} = Slice.actions;

export default Slice.reducer;
